'use client';
import { Children, useState, type ReactNode } from 'react';
import { Terminal } from '@/components/sections/kit';

/** Tabbed code panes, composed from the kit `Terminal` chrome's own tabs
 *  variant (honest toggle buttons, not the ARIA tabs pattern — see
 *  Terminal.tsx) rather than hand-rolling tab markup. `titles` arrives as a
 *  JSON string from the remark plugin (hast properties are strings);
 *  children are the shiki-rendered <pre>s in order, 1:1 with titles. */
export default function CodeTabs({ titles, children }: { titles: string; children?: ReactNode }) {
  const labels: string[] = (() => { try { return JSON.parse(titles); } catch { return []; } })();
  const panes = Children.toArray(children);
  const [active, setActive] = useState(0);
  return (
    <Terminal
      tabs={labels.map((label, i) => ({ id: String(i), label }))}
      activeTab={String(active)}
      onTabSelect={(id) => setActive(Number(id))}
      className="my-7"
    >
      {panes.map((pane, i) => (
        <div key={i} hidden={i !== active} className="[&>pre]:m-0 [&>pre]:rounded-none [&>pre]:border-0 [&>pre]:bg-transparent [&>pre]:p-0">
          {pane}
        </div>
      ))}
    </Terminal>
  );
}
